module.exports = "/images/vendor/desiigner-svg/svg/ui/play.svg?9047467bd76811ccdcb3eafaa799cb17";